"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createImShadows = createImShadows;
function createImShadows() {
  return ['none', '0px 2px 6px rgba(51, 51, 51, 0.15)',
  // default
  '0px -1px 1px rgba(16, 24, 40, 0.08), 0px 3px 3px rgba(16, 24, 40, 0.06)',
  // sm - Long
  '0px -1px 1px rgba(16, 24, 40, 0.08), 0px 6px 4px rgba(16, 24, 40, 0.06)',
  // md - Long
  '0px -1px 16px -4px rgba(16, 24, 40, 0.08), 0px 14px 8px -2px rgba(16, 24, 40, 0.05)',
  // lg - Long
  '0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px -5px 8px -4px rgba(16, 24, 40, 0.05)',
  // xl - Long
  '0px -3px 8px rgba(0, 0, 0, 0.03), 0px 24px 48px -12px rgba(16, 24, 40, 0.18)',
  // 2xl - Long
  '0px -3px 3px rgba(0, 0, 0, 0.03), 0px 32px 64px -12px rgba(16, 24, 40, 0.14)',
  // 3xl - Long
  '0px -1px 2px rgba(0, 0, 0, 0.05), 0px 1px 2px rgba(16, 24, 40, 0.05)',
  // xs - Even
  '0px 0px 8px 2px rgba(16, 24, 40, 0.08)',
  // md - Even
  '0px 0px 32px 4px rgba(16, 24, 40, 0.08)',
  // xl - Even
  'none', 'none', 'none', 'none', 'none', 'none', 'none', 'none', 'none', 'none', 'none', 'none', 'none', 'none'];
}